import React, { Component } from 'react'
import { connect } from 'react-redux'
import { IconButton, Typography } from '@material-ui/core'
import IconBack from '@material-ui/icons/ArrowBack'
import { injectIntl } from 'react-intl'
import {
  translationsLogbookEventCategoryFetchFormData,
  translationsLogbookEventCategoryClearStateForm,
  translationsLogbookEventCategoryChange,
} from 'reducers/translations/logbookEventCategory/reducer'
import { fetchProfile } from 'reducers/profile/reducer'
import withPromise from 'helpers/withPromise'
import messages from './translate'
import LogbookEventCategoryForm from './LogbookEventCategoryForm'

class LogbookEventCategoryItem extends Component {
  constructor(props) {
    super(props)
    this.state = {
      redirect: false,
    }
  }

  componentDidMount() {
    const {
      match: {
        params: { id },
      },
      translationsLogbookEventCategoryFetchFormData,
    } = this.props

    translationsLogbookEventCategoryFetchFormData({
      entityId: id,
    })
  }

  shouldComponentUpdate(nextProps, nextState) {
    const {
      history: { goBack },
    } = this.props

    if (nextState.redirect) {
      goBack()

      return false
    }

    return true
  }

  componentWillUnmount() {
    const { translationsLogbookEventCategoryClearStateForm } = this.props

    translationsLogbookEventCategoryClearStateForm()
  }

  onSubmit = values => {
    const {
      fetchProfile,
      translationsLogbookEventCategoryChange,
      match: {
        params: { id },
      },
    } = this.props
    const formatValues = { translations: [] }

    Object.keys(values).forEach(key => {
      const value = values[key]
      formatValues.translations.push({
        ...value,
        locale: key,
      })
    })

    return withPromise(translationsLogbookEventCategoryChange, {
      entityId: id,
      values: formatValues,
    })
      .then(errors =>
        errors ? Promise.resolve(errors) : this.setState({ redirect: true }),
      )
      .then(() => {
        fetchProfile()
      })
  }

  render() {
    const {
      formData,
      intl: { formatMessage },
      history: { goBack },
    } = this.props

    return (
      <div className="container-fluid no-breadcrumb">
        <Typography variant="h5" className="headline">
          <IconButton size="medium" className="btn-back" onClick={goBack}>
            <IconBack fontSize="small" />
          </IconButton>
          {formatMessage(messages.logbookEventCategoryTranslation)}
        </Typography>
        <LogbookEventCategoryForm
          formData={formData}
          onSubmit={this.onSubmit}
          {...this.props}
        />
      </div>
    )
  }
}

export default connect(
  state => ({
    formData: state
      .getIn(['logbookEventCategoryTranslations', 'formData'])
      .toJS(),
  }),
  {
    translationsLogbookEventCategoryFetchFormData,
    translationsLogbookEventCategoryClearStateForm,
    translationsLogbookEventCategoryChange,
    fetchProfile,
  },
)(injectIntl(LogbookEventCategoryItem))
